import { useState } from 'react';
import { cn } from '@utils/cn';
import { User } from 'lucide-react';

interface AvatarProps {
    src?: string | null;
    alt?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl',
};

const iconSizes = {
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
};


export function Avatar({ src, alt, size = 'md', className }: AvatarProps) {
    const [hasError, setHasError] = useState(false);

    const handleError = () => {
        setHasError(true);
    };

    // Show fallback icon if no src or image failed to load
    if (!src || hasError) {
        return (
            <div
                className={cn(
                    'rounded-full bg-dark-100 flex items-center justify-center text-dark-400',
                    sizes[size],
                    className
                )}
            >
                <User size={iconSizes[size]} />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt || 'Avatar'}
            onError={handleError}
            className={cn(
                'rounded-full object-cover bg-dark-100',
                sizes[size],
                className
            )}
        />
    );
}

export default Avatar;
